export default "__VITE_ASSET__BLNDgI0L__"